export const setImageAmount = amount => ({
  type: "SET_IMAGE_AMOUNT",
  payload: amount
});
